import { useContext } from 'react'
import styled from 'styled-components'

import DesktopProductPictureCarousel from 'productTemplate/components/DesktopProductPictureCarousel'
import ProductBreadcrumbs from 'productTemplate/components/ProductBreadcrumbs'
import ProductDetails from 'productTemplate/components/ProductDetails'
import { ProductTemplateContext } from 'productTemplate/components/ProductTemplateContextProvider'
import ProductTitle from 'productTemplate/components/ProductTitle'
import { ProductTemplateLayoutProps } from 'productTemplate/types/IProductTemplateLayoutProps'
import { renderStart } from 'shared/hocs/render'
import colors from 'shared/lib/colors'
import media from 'shared/lib/media'
import { pageWidth } from 'shared/lib/responsiveness'

const ProductTemplateDesktopLayout = (props: ProductTemplateLayoutProps) => {
  const { className } = props
  const { productTemplate } = useContext(ProductTemplateContext)
  const { brand, breadcrumbPath, description, name, pictures, productTaxonomy, releaseDate, sku } =
    productTemplate

  return (
    <ProductDesktopLayout className={className}>
      <ProductWrapper>
        <LeftLayout>
          <ProductBreadcrumbs
            breadcrumbPath={breadcrumbPath}
            name={name}
            productTaxonomy={productTaxonomy}
          />
          <DesktopProductPictureCarousel pictures={pictures} />
        </LeftLayout>
        <RightLayout>
          <ProductTitle
            brand={brand}
            name={name}
            sku={sku}
            description={description}
            releaseDate={releaseDate.shortDisplay}
          />
          <ProductDetails />
        </RightLayout>
      </ProductWrapper>
    </ProductDesktopLayout>
  )
}
export default renderStart.large(ProductTemplateDesktopLayout)

const ProductDesktopLayout = styled.div`
  margin: 0 auto;
  background-color: ${colors.FC2_WHITE};
  padding-top: 40px;
`

const ProductWrapper = styled.div`
  ${pageWidth}
  display: flex;
  justify-content: space-between;
  margin: 0 34px;
  ${media.large`
    margin: 0 auto;
  `}
`

const LeftLayout = styled.div`
  width: 65%;
`

const RightLayout = styled.div`
  width: 42%;
`
